import React from 'react';
import BlogLayout from '../Blog/BlogLayout';

export default function Sobre() {
  return (
    <BlogLayout title="Sobre" description="O Integra MKP é um dashboard criado por vendedores, para vendedores do Mercado Livre.">
      <div style={{ maxWidth: 780, margin: '0 auto', padding: '64px 24px 100px' }}>
        <h1 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 900, fontSize: 44, letterSpacing: '-0.03em', color: '#0E1430', marginBottom: 8 }}>Sobre o Integra MKP</h1>
        <div style={{ width: 60, height: 4, background: 'linear-gradient(90deg, #FFD400, #E63946, #2E7DE0)', borderRadius: 2, marginBottom: 40 }} />

        <div style={{ fontSize: 17, lineHeight: 1.75, color: '#3B4266', display: 'flex', flexDirection: 'column', gap: 20 }}>
          <p>O <strong style={{ color: '#0E1430' }}>Integra MKP</strong> nasceu de uma necessidade real: vendedores do Mercado Livre precisavam de uma ferramenta que desse controle de verdade — não apenas dados.</p>

          <p>O painel nativo do ML foi construído para servir milhões de categorias e contextos diferentes. O Integra MKP foi construído com um único objetivo: dar ao vendedor brasileiro clareza, velocidade e controle sobre o que mais importa no dia a dia.</p>

          <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 26, color: '#0E1430', marginTop: 16, letterSpacing: '-0.02em' }}>O que resolvemos</h2>

          <ul style={{ paddingLeft: 24 }}>
            {[
              'Alertas sonoros em tempo real para novos pedidos — mesmo com outras abas abertas',
              'Dashboard ao vivo sem precisar recarregar o ML repetidamente',
              'Controle de prazo FLEX com código de cores (verde, laranja, vermelho)',
              'Exportação de documentos fiscais: XML, PDF e CSV organizados por período',
              'Histórico completo de vendas e relatório mensal em 2 cliques',
            ].map((item, i) => (
              <li key={i} style={{ marginBottom: 10 }}>{item}</li>
            ))}
          </ul>

          <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 26, color: '#0E1430', marginTop: 16, letterSpacing: '-0.02em' }}>Nosso compromisso</h2>

          <p>Cobramos uma assinatura mensal acessível (menos de R$2 por dia) porque acreditamos que uma ferramenta séria precisa de um modelo de negócio sustentável — sem anúncios, sem venda de dados, sem interesses conflitantes com os seus.</p>

          <p>Os primeiros 100 usuários se tornam <strong style={{ color: '#0E1430' }}>sócios fundadores</strong> com 30% de desconto vitalício. Não é promoção — é reconhecimento por acreditar antes dos outros.</p>

          <div style={{ background: '#0A0F33', borderRadius: 14, padding: 32, marginTop: 16, textAlign: 'center' }}>
            <p style={{ color: 'rgba(250,248,243,0.8)', marginBottom: 20, fontSize: 16 }}>Ainda não testou? 7 dias grátis, sem cartão de crédito.</p>
            <a href="/" style={{ display: 'inline-block', background: '#FFD400', color: '#0A0F33', padding: '14px 32px', borderRadius: 100, fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 16, textDecoration: 'none' }}>
              Começar agora →
            </a>
          </div>

          <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 26, color: '#0E1430', marginTop: 16, letterSpacing: '-0.02em' }}>Contato</h2>
          <p>Dúvidas, sugestões ou suporte: <a href="mailto:integra.mplace@gmail.com" style={{ color: '#1B2A7A', fontWeight: 600 }}>integra.mplace@gmail.com</a></p>
        </div>
      </div>
    </BlogLayout>
  );
}
